import React, {useEffect, useState} from "react";
import {useGetBankSalesTypeQuery} from "../../../redux/api/commercialDetailApiSlice";
import {Select} from "antd";
import {LabeledValue} from "antd/lib/select";
import {DELAY_TIMER_SEARCH_FILTER, endAndStartTimerFilter} from "./columnsUtils";
import FilterContainer from "./FilterContainer";
import {FilterDropdownProps} from "antd/lib/table/interface";
export default function BankSalesTypeFilter(props: FilterDropdownProps) {
    const {data: bankSalesTypeData} = useGetBankSalesTypeQuery()
    const [options, setOptions] = useState<{label: string, value: string}[]>([])

    useEffect(()=> {
        if (bankSalesTypeData)
            setOptions(bankSalesTypeData.map(el => ({label: el.name, value: el.uuid})))
    }, [bankSalesTypeData])

    return <FilterContainer {...props}>
        <Select
            labelInValue
            options={options}
            mode={"multiple"}
            showSearch={true}
            placeholder={"Seleziona una tipologia"}
            filterOption={(input, option) => {
                return !!(option && option.label && (option.label).toLowerCase().includes(input.toLowerCase())) || !!(option && option.value && (option.value as string).toLowerCase() === (input.toLowerCase()))
            }}
            style={{width: "20rem"}}
            virtual={false}
            onChange={(values: LabeledValue[]) => {
                // @ts-ignore
                props.setSelectedKeys(values.reverse().map(el => ({label: el.label, value: el.value})))
                endAndStartTimerFilter(props.confirm, DELAY_TIMER_SEARCH_FILTER)
            }}
            // @ts-ignore
            value={props.selectedKeys}
        />
    </FilterContainer>
}